module.exports = __webpack_public_path__ + "static/media/signal.9dfe89f7.svg";